import { Box, FormControl, FormLabel, Typography } from '@mui/joy';
import { Dispatch, Fragment, useRef, useState } from 'react';
import { FileUpload, FileUploadOptions } from 'primereact/fileupload';
import { Avatar } from 'primereact/avatar';
import { Galleria } from 'primereact/galleria';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Grid } from '@mui/material';
import { Dialog } from 'primereact/dialog';
import { DataView } from 'primereact/dataview';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from 'react-router-dom';
import { RouteComponentProps } from '../../models/RouteComponent';
import { addRiskAssessment, removeRiskAssessment } from '../../service/riskAssessmentService';
import { GenericTableColumns } from '../../models/GenericTableViewModel';
import { GenericTableColumTypes, GenericTableFilterTypes } from '../../enum/TableView';
import GenericTableView from '../../components/GenericTableView';
import RiskAssessmentAdd from '../risk-assessment/risk-assessment-Add';
import { removeEquipmentChecklist, updateEquipmentChecklist } from '../../service/equipmentChecklistService';
import EquipmentChecklistView from './Equipment-checklist-View';


interface inputPrams {
  record_id: string,
  client_id?: string,
  setGlobalLoader: Dispatch<React.SetStateAction<boolean>>,
  props: RouteComponentProps
}


export default function EquipmentChecklistTable(prams: inputPrams) {
  const navigate = useNavigate();
  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const props = prams.props;

  const baseFilter = {}

  const queryParams: any = {
    'clientId': prams.client_id,
    record_id: prams.record_id
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRecord(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setSelectedRecord(row.value);
    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRecord(row.value);
  }

  const acceptFunc = async () => {
    prams.setGlobalLoader(true);
    const industry = await removeEquipmentChecklist(selectedRecord?.id);
    prams.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Equipment Checklist Deleted Successfully', life: 3000 });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

   const changeStatusFunc = async (status: boolean) => {
      props.setGlobalLoader(true);
      const client = await updateEquipmentChecklist({ "active": status }, selectedRecord?.id);
      props.setGlobalLoader(false);
      setReload(!reload);
      toast.current.show({ severity: 'success', summary: status ? 'Equipment Checklist Activated Successfully' : 'Equipment Checklist Deactivated Successfully', life: 3000 });
    }
  
    const disableConfirm = (row: any) => {
      confirmDialog({
        message: 'Are you sure you want to deactivate Equipment Checklist?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => changeStatusFunc(false)
      });
    }
  
    const activateConfirm = (row: any) => {
      confirmDialog({
        message: 'Are you sure you want to activate Equipment Checklist?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => changeStatusFunc(true)
      });
    }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const contextItems = () => {
    let objArray = [
      { label: 'View / Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm }
    ];
    if (selectedRecord?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }



  const columns: GenericTableColumns[] = [
    {
      field: 'question',
      header: 'Question',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'type',
      header: 'Type',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <Fragment>

      <GenericTableView reload={reload} queryParams={queryParams} dataKey='id' baseFilters={baseFilter} url="equipment-checklist" columns={columns} contextItems={contextItems} itemSelect={itemSelected} addButton={addButton} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRecord?.id ? `Update Equipment Checklist` : 'Add Equipment Checklist'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <EquipmentChecklistView setGlobalLoading={prams.setGlobalLoader} setReload={setReload} reload={reload} record={selectedRecord} record_id={prams.record_id} setVisible={setVisible} toast={toast} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </Fragment>
  );
}